<template>
  <div class="recycle-body">
    <div class="recycle-content" ref="scrollContainer" v-if="recycleData.list.length > 0">
      <div class="file-item-body" @click="clickSelectedItem(fileItem)" :class="{'file-item-selected' : fileItem.selected}" v-for="(fileItem,index) in recycleData.list" :key="index">
        <div class="item-selected" v-if="fileItem.data_type != 3">
          <img v-if="!fileItem.selected" src="@/assets/ic_selected_n.png" alt="" />
          <img v-else src="@/assets/ic_selected_y.png" alt="" />
        </div>
        <div class="item-body">
          <div class="file-icon">
            <img v-if="(fileItem.file_type == 1 || fileItem.file_type == 2) && (fileItem.thumb != '' && fileItem.thumb != null)" :src="fileItem.thumb" alt="Icon" />
            <img v-else :src="fileIcon[fileItem.file_type]" alt="Icon" />
          </div>
          <div class="file-content">
            <div class="file-name">
              {{ fileItem.name }}
            </div>
            <div class="file-time">
              {{ fileItem.createtime }} <label v-if="fileItem.data_type != 3">{{ fileItem.size }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="scrollContainer" v-else>
      <empty></empty>
    </div>

  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import { recycleList } from '@/utils/api/apis.js';
  import fileIcon from '@/utils/file_icon.js';
  import { throttle } from 'lodash';
  import empty from '@/components/empty.vue';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
      empty
    },
    data() {
      // 这里存放数据
      return {
        fileIcon,
        formData: {
          page: 1,
          pagesize: 25,
          orderby: 'desc'
        },
        recycleData: {
          list: [],
          total: 0
        }
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      // 加载更多
      handleScroll: throttle(function () {
        const container = this.$refs.scrollContainer;
        const scrollTop = container.scrollTop;

        // 检查是否滚动到底部，且滚动方向是向下
        if (scrollTop > this.lastScrollTop && scrollTop + container.clientHeight >= container.scrollHeight) {
          if (this.recycleData.total <= this.recycleData.list.length) return;
          this.formData.page++;
          this.getRecycleList();
        }
        this.lastScrollTop = scrollTop;
      }, 100),
      async getRecycleList() {
        try{
          var base = await recycleList(this.formData);
          base.data.list.forEach((item) => {
            item.selected = false;
          })
          this.recycleData.total = base.data.total;
          if (this.formData.page == 1) {
            this.recycleData.list = base.data.list
          } else {
            this.recycleData.list = this.recycleData.list.concat(base.data.list)
          }
          this.$emit('cleanRecycleDisplay', this.recycleData.list.length > 0 ? false : true)
        }catch(e){
          this.$toast(e);
          if (this.formData.page > 1) {
            this.formData.page--
          }
          this.$errorLog('tab_recycle/getRecycleList', e)
        }
      },
      clickSelectedItem(data) {
        data.selected = !data.selected;
        const selectedItems = this.recycleData.list.filter(item => item.selected === true);
        this.$emit('changeRecycleSelectedData', selectedItems);
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
      this.getRecycleList()
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .recycle-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    .recycle-content {
      height: calc(100vh - 200px);
      overflow-y: auto;
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
      }

      .file-item-body {
        display: flex;
        align-items: center;
        padding: 0 24px;
        height: 60px;
        .item-selected {
          width: 14px;
          height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 22px;
          img {
            width: 14px;
            height: 14px;
            object-fit: cover;
          }
        }
        .item-body {
          display: flex;
          align-items: center;
          .file-icon {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            /* margin: 0 16px 0 22px; */
            img {
              width: 32px;
              height: 32px;
              border-radius: 3px;
              object-fit: cover;
            }
          }
          .file-content {
            display: flex;
            flex-direction: column;
            margin-left: 16px;
            .file-name {
              font-size: 13px;
              font-weight: bold;
              margin-bottom: 4px;
            }
            .file-time {
              font-size: 10px;
              color: #999999;
            }
          }
        }
      }
      .file-item-selected {
        background-color: #EDF3FF;
      }
      .file-item-body:hover {
        cursor: pointer;
      }
    }
  }
  .tab-content-file {
    height: calc(100vh - 260px);
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
  .default-body {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .default {
      width: 100px;
      height: 100px;
      img {
        width: 100px;
        height: 100px;
      }
    }
    .tips {
      color: #999999;
      font-size: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/tab_recycle.vue